import React from "react"
import PSESection from "../preview/section/PSESection"
import { PSE_BLOCK_TYPES } from "../../../utils/productionStepExecution"
import ProductionStepExecutionMachinesForm from "./ProductionStepExecutionMachinesForm"

const ProductionStepExecutionCoolingFormContainer = ({
	productionStepExecution,
	machinesOptions,
	handleSubmit,
	updateErrorMessage,
	isEnd = false,
	visible,
	setNextButtonStatus
}) => {

	if (!visible) {
		return null
	}

	return (
		<PSESection
			productionStepExecution={productionStepExecution}
			sectionType={PSE_BLOCK_TYPES.COOLING}
			title="Refroidissement"
			subtitle={`Saisissez l'heure et la température de ${isEnd ? "fin " : "début "}de refroidissement.`}
		>
			<ProductionStepExecutionMachinesForm
				mode={isEnd ? PSE_BLOCK_TYPES.COOLING_END : PSE_BLOCK_TYPES.COOLING}
				machinesBatch={productionStepExecution.machinesBatch}
				machinesOptions={machinesOptions}
				onSubmit={handleSubmit}
				onError={updateErrorMessage}
				setNextButtonStatus={setNextButtonStatus}
			/>
		</PSESection >
	)
}

export default ProductionStepExecutionCoolingFormContainer